import { useAvisoLimitesTipos, useMensagensRevisaoCondicoes } from "./use-aviso-condicoes";
import { AvisoLimitesTiposView, MensagensRevisaoCondicoesView } from "./view-aviso-condicoes";

export function AvisoLimitesTipos() {
  const vm = useAvisoLimitesTipos();

  return <AvisoLimitesTiposView {...vm} />;
}

export function MensagensRevisaoCondicoes() {
  const vm = useMensagensRevisaoCondicoes();

  return <MensagensRevisaoCondicoesView {...vm} />;
}

export type * from "./types-aviso-condicoes";
